import React from 'react';

const Attributes = (props) => {
    return (
        <div className="p-4 border rounded">
            {
                props.data.map((i,idx) => {
                    return (
                        <div>
                            <text className="text-monospace"><b>{i.name} </b>
                                <span className="badge badge-info">
                                    {i.type}
                                </span>
                                {" "}
                                { i.required ?
                                    <span className="badge badge-danger">
                                        required
                                    </span> :
                                    i.required === 'optional' ?
                                        <span className="badge badge-warning">
                                            optional
                                        </span> :
                                        null
                                }
                            </text>
                            <br/>
                            <p>{i.description}</p>
                            { idx+1 === props.data.length ? null : <hr className="my-3"/> }
                            {
                                i.items ?
                                    i.items.map((j,jdx) => {
                                        return (
                                            <div className="pl-4">
                                                <text className="text-monospace"><text className="text-muted">{i.name}.</text><b>{j.name} </b>
                                                    <span className="badge badge-info">
                                                        {j.type}
                                                    </span>
                                                    {" "}
                                                    { j.required ?
                                                        <span className="badge badge-danger">
                                                            required
                                                        </span> :
                                                        j.required === 'optional' ?
                                                        <span className="badge badge-warning">
                                                            optional
                                                        </span> :
                                                            null
                                                    }
                                                </text>
                                                <br/>
                                                <p>{j.description}</p>
                                                { jdx+1 === i.items.length ? null : <hr className="my-3"/> }
                                            </div>
                                            )
                                    })  : null
                            }
                        </div>
                    )
                })
            }
        </div>
    )
};

export default Attributes
